import {  Component, Input } from '@angular/core';
import { ChamelionOffer } from '@app/models/offerpack/ChamelionOffer';

@Component({
    selector: 'clever-getyourguide-mini-detail',
    templateUrl: './getyourguide-mini-detail.component.html',
    styleUrls: ['./getyourguide-mini-detail.component.scss'],
    standalone: false
})
export class GetyourguideMiniDetailComponent {
    @Input() datas: ChamelionOffer;
    constructor() { }
}
